import axios, { isAxiosError } from "axios";
// See https://stackoverflow.com/
// questions/40941118/axios-wont-send-cookie-ajax-xhrfields-does-just-fine

import config from "@/config";

// ///////////////////////////////////////////////////////////////////////////////////////
//
// Base api
//
// ///////////////////////////////////////////////////////////////////////////////////////
// Set default authorization headers for all requests if we have a sessionId
const sessionId = localStorage.getItem("session-id");
if (sessionId) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + sessionId;
}
const API_HOST = config.apiHostUrl;
const axiosOptions = {
  baseURL: (typeof API_HOST === "undefined" ? "http://localhost:8888" : API_HOST) + "/v1",
};
export const api = axios.create(axiosOptions);

// Endpoint + error name pairs that are expected and should not be logged to Sentry
const ignoredErrors: { url: string; errorName: string }[] = [
  { url: "/translate/property", errorName: "translation-engine/unsupported-language-pair" },
];

/** Check if an axios error is an expected error that should not be logged to Sentry */
export function isExpectedApiError(err: unknown): boolean {
  if (!isAxiosError(err)) return false;
  const url = err.config?.url || "";
  const errorName = err.response?.data?.error?.name || "";
  return ignoredErrors.some((e) => url.includes(e.url) && errorName === e.errorName);
}

// Log server error responses to help debug issues
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 400 && !isExpectedApiError(error)) {
      console.error(
        `API Error interceptor: ${error.response.status} ${error.config?.method?.toUpperCase()} ${error.config?.url}`,
        JSON.stringify(error.response.data)
      );
    }
    return Promise.reject(error);
  }
);
